@let _showChat = aida.isChatView();
@if (aida.isEnabled()) {
	<ada-drawer
		adaStateful="aida.drawer"
		collapseIcon="faTimes"
		contentPadding="0px"
		drawerPadding="0px"
		drawerPosition="right"
		drawerTitle="Ask {{ aida.displayName() }}"
		triggerIcon="faTimes"
		[collapsedSize]="0"
		[expandedSize]="llmDrawerWidth()"
		[hideSplitterWhenCollapsed]="true"
		[isClickableHeader]="false"
		[isCollapsed]="!aida.isOpen()"
		(isCollapsedChange)="aida.isOpen.set(!$event)"
	>
		@if (hasAidaLicense()) {
			@let _buttonText = _showChat ? 'Manage AI-enabled Products' : 'Back to Chat';

			<button
				class="ada-btn ada-btn-small"
				data-container-selector="ada-drawer-header"
				data-testid="ada-admin-portal-body-llm-view-toggle"
				[attr.aria-label]="_buttonText"
				[attr.title]="_buttonText"
				[class.ada-btn-flat]="_showChat"
				[class.ada-btn-no-padding]="_showChat"
				[class.ada-btn-outline]="!_showChat"
				[style.float]="'right'"
				[style.margin-right]="ui.Spacing.SPACING_MEDIUM"
				(click)="onLlmViewToggle($event)"
			>
				<ada-icon [icon]="_showChat ? 'faCartShopping' : 'faArrowLeft'" />
				@if (!_showChat) {
					<span [style.margin-left]="ui.Spacing.SPACING_MEDIUM">{{ _buttonText }}</span>
				}
			</button>
		}
		<ada-llm data-container-selector="ada-drawer-drawerContent" />
		<div
			class="ada-admin-portal-body-content ada-full-height ada-overflowY-hidden ada-overflowX-hidden"
			data-container-selector="ada-drawer-mainContent"
		>
			@if (llmArtifacts.isOpen()) {
				<ada-llm-artifact-viewer adaStateful="aida.artifacts.viewer" />
			}

			<ng-container *ngTemplateOutlet="BodyContent" />
		</div>
	</ada-drawer>
} @else {
	<ng-container *ngTemplateOutlet="BodyContent" />
}

<ng-template #BodyContent>
	<ada-splitter [sizes]="splitterSizes()">
		<router-outlet *adaTemplateMarker />
		@for (panel of panelService.panels(); track $index) {
			<ng-container *adaTemplateMarker>
				<ng-container *ngComponentOutlet="panel.componentType; inputs: panel.inputs" />
			</ng-container>
		}
	</ada-splitter>
</ng-template>
